import { useQuery } from "react-query";
import { IAddress } from "../types/index";
import axios from "axios";

const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getAddressLineType = async (): Promise<IAddress[]> => {
  const { data } = await axios.get(`${api_base_url}/AddressLineType`);
  return data;
};

export const useGetAddressLineType = () => {
  return useQuery("AddressLineType", getAddressLineType, {
    refetchOnWindowFocus: false,
  });
};
